import React from "react";

export default function EventItemComponent(props) {
  const {
    title,
    facilitated_by,
    start_date,
    start_time,
    location,
    who_can_attend,
    event_id,
  } = props.item;

  
  return (
    <div className="col-lg-4 col-md-6">
      <div className="single-service">
        <h4>{title ?? "Resume Writing 222"}</h4>
        <h6>{facilitated_by ?? "Facilitated By Learning Partners"}</h6>
        <p className="pt-20">
          <span>
            <i className="fa fa-calendar" /> &nbsp;{" "}
            {start_date ?? "30 Nov 2019"}
          </span>
          <br />
          <span>
            <i className="fa fa-clock-o" /> &nbsp; {start_time ?? "5 - 6 pm"}
          </span>
          <br />
          <span>
            <i className="fa fa-thumb-tack" /> &nbsp;{" "}
            {location ?? "Chandigarh &amp; Delhi"}
          </span>
          <br />
          <span>
            <i className="fa fa-user" /> &nbsp;{" "}
            {who_can_attend ?? "For LGBT+ Community only"}
          </span>
          <br />
          <span>
            <i className="fa fa-book" /> &nbsp; EV-{event_id ?? "1"}
          </span>
        </p>
      </div>
    </div>
  );
}
